import store from '@/store'

export default [
  {
    path: '/admin/roles',
    name: 'role',
    meta: { requiresAuth: true },
    component: () => import('@/pages/security/role')
  },
  {
    path: '/admin/roles/create',
    name: 'role-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/security/role/create.vue')
  },
  {
    path: '/admin/roles/:id',
    name: 'role-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/security/role/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('security/role/find', to.params.id)
      next()
    }
  }
]
